import Vue from 'vue'

const state = {
  cache: {

  },
}

const getters = {
}

const actions = {
}

const mutations = {
  updateCache (state, { key, value }) {
    Vue.set(state.cache, key, value)
  },
  clearKeyCache (state, key) {
    Vue.set(state.cache, key, null)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
